import EllipsisOutlined from "@ant-design/icons/EllipsisOutlined";
import React, { useMemo } from "react";
import Button from "common/Buttons/Button";
import { openMessage } from "utils/misc";
import Dropdown from "common/Dropdown/Dropdown";
import useEditTradeExtraInfo from "@shared/features/trades/EditTrade/useEditTradeExtraInfo";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

const EditTradeExtraActions = () => {
  const { t } = useTypedTranslation(LanguageNameSpaces.TRADES);
  const actions = useEditTradeExtraInfo({ openMessage });

  const menuItems = useMemo(
    () =>
      actions.map((action) => {
        if (action.isInvalid) return { ...action, className: "invalid" };
        return action;
      }),
    [actions]
  );

  return (
    <Button>
      <Dropdown
        title={t("labels.add_amount")}
        menu={{ items: menuItems }}
        trigger={["click"]}
      >
        <EllipsisOutlined
          style={{
            fontSize: 28,
            cursor: "pointer",
            position: "relative",
          }}
        />
      </Dropdown>
    </Button>
  );
};

export default EditTradeExtraActions;
